<template>
  <div id="aperturaSubsede">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs12 >
          <h4 class="grey--text text--darken-1">
            <v-icon small color="primary">drag_indicator</v-icon> Trámite / Subsede
          </h4>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 v-if="this.apertura.devolucion == 1">
          <v-card>
            <v-card-text>
              <h3>Observación</h3>
              <p>{{ observacion }}</p>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-card>
        <v-card-title class="headline lighten-3">
          <span class="headline">Trámite de Apertura Subsede</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="form_apertura">
            <v-layout row wrap>
              <v-flex xs9 class="py-0">
                <v-text-field
                  type="text"
                  label="Nombre de Subsede"
                  v-model="apertura.institucional.nombre"
                  :rules="[v => !!v || 'El campo es requerido']"
                  class="txt-upper"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 class="py-0">
                <v-text-field
                  type="text"
                  label="Sigla"
                  v-model="apertura.institucional.sigla"
                  class="txt-upper"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md3 class="py-0">
                <v-select
                  :items="departamentos"
                  label="Departamento"
                  item-text="lugar"
                  item-value="id"
                  v-model="apertura.institucional.departamento_id"
                  @change="getProvincias(apertura.institucional.departamento_id)"
                  :rules="[v => !!v || 'Seleccione una opción']"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs6 md3 class="py-0">
                <v-select
                  :items="provincias"
                  label="Provincia"
                  item-text="lugar"
                  item-value="id"
                  v-model="apertura.institucional.provincia_id"
                  @change="getMunicipios(apertura.institucional.provincia_id)"
                  :rules="[v => !!v || 'Seleccione una opción']"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs6 md3 class="py-0">
                <v-select
                  :items="municipios"
                  label="Municipio"
                  item-text="lugar"
                  item-value="id"
                  v-model="apertura.institucional.municipio_id"
                  @change="getComunidades(apertura.institucional.municipio_id)"
                  :rules="[v => !!v || 'Seleccione una opción']"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs6 md3 class="py-0">
                <v-select
                  :items="comunidades"
                  label="Comunidad"
                  item-text="lugar"
                  item-value="id"
                  v-model="apertura.institucional.comunidad_id"
                  :rules="[v => !!v || 'Seleccione una opción']"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12 sm7 md9 class="pt-0 pb-1">
                <v-text-field
                  type="text"
                  label="Dirección"
                  v-model="apertura.institucional.direccion"
                  :rules="[v => !!v || 'El campo es requerido']"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm5 md3 class="pt-0 pb-1">
                <v-text-field
                  type="text"
                  label="Zona"
                  v-model="apertura.institucional.zona"
                  :rules="[v => !!v || 'El campo es requerido']"
                  required
                ></v-text-field>
              </v-flex>
              <!-- <v-flex xs12 sm6 class="pt-0 pb-1">
                <v-text-field
                  type="number"
                  label="Teléfono"
                  v-model="apertura.institucional.telefono"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="pt-0 pb-1">
                <v-text-field
                  type="text"
                  label="Correo Electrónico"
                  v-model="apertura.institucional.correo"
                  required
                ></v-text-field>
              </v-flex> -->
              <v-flex xs12 sm6 class="pt-0 pb-1">
                <v-text-field
                  type="text"
                  label="Geolocalización"
                  v-model="apertura.institucional.geolocalizacion"
                  append-icon="map"
                  readonly
                  @click="dialogMap = true"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 class="my-0 py-0">
                <v-card-title class="grey lighten-4 py-0 px-1">
                  <h3 class="grey--text text--darken-1">Curso(s) de Capacitación</h3>
                  <v-spacer></v-spacer>
                  <v-btn flat small outline color="primary" @click="showDialogCurso">Agregar Curso</v-btn>
                </v-card-title>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12 class="pt-0">
                <v-data-table
                  :headers="headerCurso"
                  :items="apertura.cursos_capacitacion"
                  class="elevation-1"
                  no-data-text="No existen registros"
                  hide-actions
                >
                  <template v-slot:items="props">
                    <td>{{ props.index + 1 }}</td>
                    <td>{{ props.item.curso_nombre }}</td>
                    <td>{{ props.item.carga_horaria }}</td>
                    <td>{{ props.item.tiempo }}</td>
                    <td>
                      <v-btn-toggle>
                        <v-btn
                          v-if="props.item.turno_m"
                          small
                          class="transparent"
                        >
                          Mañana
                        </v-btn>
                        <v-btn
                          v-if="props.item.turno_t"
                          small
                          class="transparent"
                        >
                          Tarde
                        </v-btn>
                        <v-btn
                          v-if="props.item.turno_n"
                          small
                          class="transparent"
                        >
                          Noche
                        </v-btn>
                      </v-btn-toggle>
                    </td>
                    <td>
                      <v-tooltip bottom>
                        <template v-slot:activator="{on}">
                          <v-btn
                            v-on="on"
                            icon
                            dark
                            small
                            color="red"
                            @click="removeCurso(props.index)"
                          >
                            <v-icon small>delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Quitar registro</span>
                      </v-tooltip>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 class="my-0 pt-0 pb-2">
                <v-card-title class="grey lighten-4 py-1 px-1">
                  <h3 class="grey--text text--darken-1">Requisitos</h3>
                </v-card-title>
                <v-divider class="mb-0"></v-divider>
              </v-flex>
              <v-flex xs12 md6 class="py-0">
                <v-checkbox
                  v-model="apertura.requisito.nota_solicitud"
                  label="Nota de Solicitud"
                  :rules="[v => !!v || 'Marque la opción']"
                  class="my-0 py-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 class="py-0">
                <v-checkbox
                  label="CI Propietario/Representante legal"
                  v-model="apertura.requisito.ci_propietario_representante"
                  class="my-0 py-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 class="py-0">
                <v-checkbox
                  label="NIT"
                  v-model="apertura.requisito.nit"
                  class="my-0 py-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 class="py-0">
                <v-checkbox
                  label="FUNDEMPRESA"
                  v-model="apertura.requisito.fundempresa"
                  class="my-0 py-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 class="py-0">
                <v-checkbox
                  label="Poder Notarial (si corresponde)"
                  v-model="apertura.requisito.poder_notarial"
                  class="my-0 py-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 class="py-0">
                <v-checkbox
                  label="Folio Real (propietario)/form. información rápida(inquilino)"
                  v-model="apertura.requisito.folio_real"
                  class="my-0 py-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 class="py-0">
                <v-checkbox
                  label="Contrato Alquiler (original/fotocopia legalizada)"
                  v-model="apertura.requisito.contrato_alquiler"
                  class="my-0 py-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 class="py-0">
                <v-checkbox
                  label="Plano de Infraestructura"
                  v-model="apertura.requisito.plano_infraestructura"
                  class="my-0 py-0"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 class="my-0 py-0">
                <v-card-title class="grey lighten-4 py-1 px-1">
                  <h3 class="grey--text text--darken-1">Proyecto Educativo Institucional</h3>
                </v-card-title>
                <v-divider class="mb-0"></v-divider>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <h4 class="grey--text text--darken-2 mb-2">Documentos Institucionales</h4>
                <v-checkbox v-model="apertura.requisito.reglamento_interno" label="Reglamento Interno" class="my-0 py-0"></v-checkbox>
                <v-checkbox v-model="apertura.requisito.infraestructura" label="Infraestructura" class="my-0 py-0"></v-checkbox>
                <v-checkbox v-model="apertura.requisito.espacio_administrativo" label="Espacio Administrativo" class="my-0 py-0"></v-checkbox>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <h4 class="grey--text text--darken-2 mb-2">Equipamiento</h4>
                <v-checkbox v-model="apertura.requisito.maquinaria_equipo" label="Maquinaria y Equipos" class="my-0 py-0"></v-checkbox>
                <v-checkbox v-model="apertura.requisito.herramienta" label="Herramientas" class="my-0 py-0"></v-checkbox>
                <v-checkbox v-model="apertura.requisito.instrumento" label="Instrumentos" class="my-0 py-0"></v-checkbox>
                <v-checkbox v-model="apertura.requisito.tarjeta_propiedad" label="Tarjeta Propiedad (caso de autoescuela)" class="my-0 py-0"></v-checkbox>
              </v-flex>
            </v-layout>
            <div class="text-xs-center mt-3">
              <v-btn color="primary" dark @click="confirmSolicitudApertura">Guardar</v-btn>
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog v-model="dialogCurso" scrollable :width="(size_width>1024?'60%':'100%')">
      <v-card>
        <v-card-title class="headline grey lighten-3">
          <span class="headline">Agregar Curso</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-lg fluid class="py-1">
            <v-form ref="form_curso">
              <v-layout row wrap>
                <v-flex xs12 class="py-0">
                  <v-select
                    :items="facilitadores"
                    label="Facilitadores"
                    item-text="nombre"
                    item-value="id"
                    v-model="curso.facilitador_id"
                    :rules="[v => !!v || 'Seleccione una opción']"
                  ></v-select>
                </v-flex>
                <v-flex xs6 class="py-0">
                  <v-autocomplete
                    :items="cursos"
                    label="Curso"
                    item-text="curso"
                    item-value="id"
                    v-model="curso.curso_capacitacion"
                    :rules="[v => !!v || 'Seleccione una opción']"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs3 class="py-0">
                  <v-text-field
                    type="text"
                    label="Carga Horaria"
                    v-model="curso.carga_horaria"
                    :rules="[v => !!v || 'El campo es requerido', v => (!!v && v > 19) || 'Valor mínimo 20', v => (!!v && v < 301) || 'Valor máximo 300']"
                    @keypress="isNumber($event)"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs3 class="py-0">
                  <v-text-field
                    type="text"
                    label="Tiempo (Mes)"
                    v-model="curso.tiempo"
                    :rules="[v => !!v || 'El campo es requerido', v => (!!v && v > 0) || 'Valor mínimo 1', v => (!!v && v < 5) || 'Valor máximo 4']"
                    @keypress="isNumber($event)"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 class="my-0 pb-0">
                  <h3 class="grey--text text--darken-1">Turno</h3>
                </v-flex>
                <v-flex xs12 sm4 md4 class="py-0">
                  <v-checkbox
                    class="my-0"
                    v-model="curso.turno_m"
                    label="Mañana"
                    hide-details
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 sm4 md4 class="py-0">
                  <v-checkbox
                    class="my-0"
                    v-model="curso.turno_t"
                    label="Tarde"
                    hide-details
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 sm4 md4 class="py-0">
                  <v-checkbox
                    class="my-0"
                    v-model="curso.turno_n"
                    label="Noche"
                    hide-details
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success darken-1" flat @click="agregarCurso">
            Agregar
          </v-btn>
          <v-btn color="blue darken-1" flat @click="dialogCurso = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogMap" persistent :width="(size_width>1024?'51%':'90%')">
      <v-card>
        <v-card-title class="headline grey lighten-3">
          <span class="headline">Geolocalización</span>
        </v-card-title>
        <v-card-text class="text-xs-center">
          <p class="grey--text text--darken-2">Marque la ubicación de la Subsede.</p>
          <div id="geomap" style="width: 100% !important; height: 50vh"></div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialogMap = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mconfirm" persistent width="300px">
      <v-card>
        <v-card-title class="headline grey lighten-3">
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-card-text class="text-xs-center">
          <p :class="color_txt + '--text text--darken-2 subheading'">
            {{ message }}
          </p>
          <v-btn
            v-if="hide_accept == false"
            :loading="loadingPrint"
            outline
            color="primary"
            @click="formularioCctpSs"
            class="mt-3"
          >
            Imprimir Formulario
          </v-btn>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="hide_accept" :loading="loading" color="success darken-1" flat @click="createTramiteApertura">
            Aceptar
          </v-btn>
          <v-btn color="blue darken-1" flat @click="closeDialog">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snack.state"
      top
      right
      :timeout="2500"
      :color="snack.color"
      :multi-line="snack.mode === 'multi-line'"
    >
      {{ snack.text }}
    </v-snackbar>
  </div>
</template>

<script>
import Service from "../services/general";
import axios from "axios";
export default {
  data: () => ({
    loading: false,
    loadingPrint: false,
    color_txt: '',
    hide_accept: true,
    loadingSegip: false,
    active: null,
    headerCurso: Service.headerTable().curso,
    fechaNacProp: false,
    fechaNacRep: false,
    fechaNacPrs: false,
    departamentos: [],
    provincias: [],
    municipios: [],
    comunidades: [],
    cursos: [],
    facilitadores: [],
    apertura: {
      tramite_id: '',
      devolucion: 0,
      institucioneducativa_id: '',
      tipo_tramite: [],
      institucional: {
        sede_central: false,
        nombre: 'Subsede ',
        sigla: '',
        departamento_id: '',
        departamento_nombre: '',
        provincia_id: '',
        provincia_nombre: '',
        municipio_id: '',
        comunidad_id: '',
        direccion: '',
        zona: '',
        calle: '',
        telefono: '',
        correo: '',
        geolocalizacion: ''
      },
      cursos_capacitacion: [],
      requisito: {
        nota_solicitud: false,
        ci_propietario_representante: false,
        nit: false,
        fundempresa: false,
        poder_notarial: false,
        folio_real: false,
        contrato_alquiler: false,
        plano_infraestructura: false,
        reglamento_interno: false,
        infraestructura: false,
        espacio_administrativo: false,
        maquinaria_equipo: false,
        herramienta: false,
        instrumento: false,
        tarjeta_propiedad: false
      }
    },
    curso: {
      facilitador_id: '',
      curso_nombre: '',
      curso_capacitacion: '',
      carga_horaria: '',
      tiempo: '',
      turno_m: false,
      turno_t: false,
      turno_n: false
    },
    observacion: '',
    /* emailRules: [
      (v) => !!v || 'E-mail is required',
      (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
    ], */
    size_width: 0,
    dialogCurso: false,
    dialogMap: false,
    mconfirm: false,
    tramite_id: '',
    map: null,
    snack: {
      state: false,
      color: "success",
      mode: "",
      timeout: 2500,
      text: ""
    },
    message: ""
  }),
  mounted() {
    this.dparams = Service.getParams();
    if (this.dparams && this.dparams.roluser != Service.rol().director) {
      this.$router.push({name: 'principal'});
    }
    if (this.dparams != null) {
      this.getDepartamentos(1);
      this.getCursosFacilitadores();
      var lmarker, cmarker;
      this.map = new mapboxgl.Map({
        container: 'geomap',
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [-63.588654, -16.290154], 
        zoom: 4
      });
      this.map.addControl(new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl: mapboxgl,
        countries: 'bo',
        placeholder: 'Buscar lugar',
        zoom: 11
      }));
      this.map.addControl(new mapboxgl.NavigationControl());
      this.map.doubleClickZoom.disable();
      let self = this;
      this.map.on('click', ev => {
        if (lmarker) {
          lmarker.remove();
        }
        cmarker = new mapboxgl.Marker()
        .setLngLat([ev.lngLat.lng, ev.lngLat.lat])
        .addTo(this.map);
        self.apertura.institucional.geolocalizacion = JSON.stringify([ev.lngLat.lat, ev.lngLat.lng]);
        lmarker = cmarker;
      });
    }
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWidth);
      this.getWidth();
    });
    if (Service.getTramiteId() != null) {
      this.apertura.tramite_id = Service.getTramiteId();
      this.apertura.devolucion = 1;
      this.getDatos(this.apertura.tramite_id);
    }
  },
  methods: {
    getWidth() {
      this.size_width = document.documentElement.clientWidth;
    },
    getDepartamentos(pais_id) {
      Service.lugarTipo(Service.nivel().departamento, pais_id).then(response => {
        this.departamentos = response.data;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getProvincias(departamento_id) {
      Service.lugarTipo(Service.nivel().provincia, departamento_id).then(response => {
        this.provincias = response.data;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getMunicipios(provincia_id) {
      Service.lugarTipo(Service.nivel().municipio, provincia_id).then(response => {
        this.municipios = response.data;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getComunidades(municipio_id) {
      Service.lugarTipo(Service.nivel().comunidad, municipio_id).then(response => {
        this.comunidades = response.data;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getCursosFacilitadores() {
      Service.cursosFacilitadores(this.dparams.ie_id).then(response => {
        this.cursos = response.data.cursos;
        this.facilitadores = response.data.facilitadores;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    confirmSolicitudApertura() {
      if (this.$refs.form_apertura.validate()) {
        if (this.apertura.cursos_capacitacion.length > 0) {
          this.color_txt = 'grey';
          this.hide_accept = true;
          this.message = '¿Está seguro de enviar la Solicitud de Trámite de Apertura con la información ingresada?';
          this.mconfirm = true;
        } else {
          this.toast('warning', 'Debe agregar el/los curso(s) de capacitación');
        }
      } else {
        this.toast('warning', 'Debe completar los datos del formulario');
      }
    },
    createTramiteApertura() {
      this.loading = true;
      this.apertura.institucional.sigla = (this.apertura.institucional.sigla == '' ? this.apertura.institucional.sigla : this.apertura.institucional.sigla.toUpperCase());
      this.apertura.institucional.nombre = this.apertura.institucional.nombre.toUpperCase();

      var indexDepto = this.departamentos.findIndex(x => x.id === this.apertura.institucional.departamento_id);
      var nombreDepartamento = (indexDepto != -1) ? this.departamentos[indexDepto].lugar : '';
      this.apertura.institucional.departamento_nombre = nombreDepartamento;
      var indexProv = this.provincias.findIndex(x => x.id === this.apertura.institucional.provincia_id);
      var nombreProvincia = (indexProv != -1) ? this.provincias[indexProv].lugar : '';
      this.apertura.institucional.provincia_nombre = nombreProvincia;

      this.dparams.tramite_id = this.apertura.tramite_id;
      this.dparams.tipo_tramite = [8];
      this.dparams.flujotipo_id = Service.getFlujoTipo().flujo_m;// 17;
      
      this.apertura.institucioneducativa_id = this.dparams.ie_id;
      this.apertura.tipo_tramite = this.dparams.tipo_tramite;
      axios
        .post(Service.getBase() + 'inicio/apertura/subsede', { params: this.dparams, datos: JSON.stringify(this.apertura) }, Service.getHeader())
        .then(response => {
          this.loading = false;
          if (response.data.estado == 200) {
            this.tramite_id = response.data.tramite_id;
            this.color_txt = 'success';
            this.$refs.form_apertura.reset();
            this.apertura.institucional.nombre = 'Centro de Capacitación Técnica ';
            this.hide_accept = false;
          } else {
            this.color_txt = 'error';
            this.hide_accept = true;
          }
          this.message = response.data.msg;
        })
        .catch(error => {
          this.loading = false;
          this.color_txt = 'error';
          this.hide_accept = true;
          this.message = "No se pudo registrar la Solicitud del Trámite de Apertura";
          console.error("Error al guardar", error);
        });
    },
    showDialogCurso() {
      this.$refs.form_curso.reset();
      this.dialogCurso = true;
    },
    agregarCurso() {
      if(this.$refs.form_curso.validate()) {
        if ((this.curso.turno_m == undefined || this.curso.turno_m == false) && (this.curso.turno_t == undefined || this.curso.turno_t == false) && (this.curso.turno_n == undefined || this.curso.turno_n == false)) {
          this.toast('warning', 'Marque por lo menos una o todos los turnos.');
        } else {
          let curso_id = this.cursos.findIndex(x => x.id === this.curso.curso_capacitacion);
          this.curso.curso_nombre = this.cursos[curso_id].curso;
          this.apertura.cursos_capacitacion.push(this.curso);
          this.curso = {
            curso_nombre: '',
            curso_capacitacion: '',
            carga_horaria: '',
            tiempo: '',
            turno_m: false,
            turno_t: false,
            turno_n: false
          };
          this.dialogCurso = false;
        }
      }
    },
    removeCurso(index) {
      this.apertura.cursos_capacitacion.splice(index, 1);
    },
    closeDialog() {
      if (this.hide_accept == false) {
        Service.removeTramiteId();
        this.$router.push({name: 'tramite/recibido'});
      }
      this.mconfirm = false;
    },
    formularioCctpSs() {//this.tramite_id=1671420;// 1671386;
      this.loadingPrint = true;
      axios.get(Service.getBase() + 'tramite/tarea/1/' + this.tramite_id, Service.getHeader()).then(response => {
        this.loadingPrint = false;
        var datos = (response.data.datos != '') ? JSON.parse(response.data.datos) : {};
        Service.formularioCctpSubsede(datos);
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getDatos(tramite_id) {
      axios
        .get(Service.getBase() + "tramite/tareaobs/5/" + tramite_id, Service.getHeader())
        .then(async (response) => {
          if (response.data.datos !='') {
            this.observacion = response.data.observacion;
            this.tarea = JSON.parse(response.data.datos);
            await this.getProvincias(this.tarea.institucional.departamento_id);
            await this.getMunicipios(this.tarea.institucional.provincia_id);
            await this.getComunidades(this.tarea.institucional.municipio_id);
            this.apertura.institucional = this.tarea.institucional;
            this.apertura.cursos_capacitacion = this.tarea.cursos_capacitacion;
            // this.apertura.facilitadores = this.tarea.facilitadores;
            this.apertura.requisito = this.tarea.requisito;
          }
        })
        .catch(error => {
          console.error("Error al cargar registros", error);
        });
    },
    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWidth);
  }
};
</script>
